import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Card, Button } from "react-bootstrap";

const DOMPurify = require("dompurify")(window);

function InsurranceItem({ title, description, image, slug }) {
  const history = useNavigate();

  const { t } = useTranslation();

  return (
    <Card className="d-flex flex-fill">
      <Card.Img variant="top" src={image} alt={title} />
      <Card.Header className=" border-0 bg-white d-block mx-auto text-center">
        {title}
      </Card.Header>
      <Card.Body className="flex-fill insurrance-card__body">
        <Card.Text
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(description.slice(0, 324) + "..."),
          }}
        ></Card.Text>
      </Card.Body>
      <Card.Footer className="border-0 bg-white d-block mx-auto">
        <Button
          onClick={() => history(`/insurrances/${slug}`, { replace: true })}
          className="u-mb-medium btn btn-blue"
        >
          {t("learn-more_button")}
        </Button>
      </Card.Footer>
    </Card>
  );
}

export default InsurranceItem;
